import { createFormConfig, ValidationRules } from "helpers/createFormConfig";
import { TenantFormFieldNames } from "../types/tenantFormFieldNames";
import { TenantFormValues } from "../types/tenantFormValues";
import { buildTenantValidationRules } from "./tenantValidationRules";

const defaultValues = {
  [TenantFormFieldNames.Civility]: 'Mr',
  [TenantFormFieldNames.Guarantor]: undefined,
};

/** Config du formulaire locataire — les règles dépendent de la date de début du contrat. */
const buildTenantFormConfig = (contractStartDate?: Date | null) =>
  createFormConfig<TenantFormValues>(
    buildTenantValidationRules(contractStartDate) as ValidationRules<keyof TenantFormValues>,
    defaultValues
  );

/** Compat : config avec la date du jour comme référence. */
const tenantFormConfig = buildTenantFormConfig();

export { tenantFormConfig, buildTenantFormConfig };
